import { api } from './api';
import type { GnRole } from '../components/gn/GnContext';

export interface InkInterpretation {
  text: string;
  confidence: number;
  confidenceThreshold: number;
}

/** Handwriting interpretation (spec 046 FR-021). imageBase64 has no `data:` prefix. */
export async function interpretInk(role: GnRole, imageBase64: string): Promise<InkInterpretation> {
  const response = await api.post<{ data: InkInterpretation }>(`/api/${role}/gn/ink/interpret`, { imageBase64 });
  return response.data.data;
}
